"use client";

import { ChartLineInteractive } from "@/components/hlidaci-pes/ChartLineInterActive";
import LoadingOverlayDots from "@/components/hlidaci-pes/LoadingLayoverDots";
import WatchDogSpecificResults from "@/components/hlidaci-pes/WatchDogSpecificResults";
import WatchDogSpecificResultsList from "@/components/hlidaci-pes/WatchDogSpecificResultsList";
import { WatchDogResultsAnalyticsPanel } from "@/components/hlidaci-pes/watchdog-page/WatchDogResultsAnalyticsPanel";
import { HintWindow } from "@/components/ui/HintWindow";
import { Panel } from "@/components/ui/Panel";

type WatchDogResultsSectionProps = {
  hasSelectedDog: boolean;
  hasResults: boolean;
  isGraphView: boolean;
  isCompactView: boolean;
  isResultsLoading: boolean;
  showResultsEmptyState: boolean;
  emptyStateText: string;
};

export function WatchDogResultsSection({
  hasSelectedDog,
  hasResults,
  isGraphView,
  isCompactView,
  isResultsLoading,
  showResultsEmptyState,
  emptyStateText,
}: WatchDogResultsSectionProps) {
  if (!hasSelectedDog) return null;

  return (
    <HintWindow>
      <Panel variant="shell">
        <WatchDogResultsAnalyticsPanel />

        {isResultsLoading ? (
          <Panel>
            <LoadingOverlayDots />
          </Panel>
        ) : showResultsEmptyState ? (
          <Panel>
            <p className="app-card-description">{emptyStateText}</p>
          </Panel>
        ) : hasResults ? (
          isGraphView ? (
            <ChartLineInteractive />
          ) : isCompactView ? (
            <WatchDogSpecificResults />
          ) : (
            <WatchDogSpecificResultsList />
          )
        ) : null}
      </Panel>
    </HintWindow>
  );
}
